import {browser} from '@/models/browser.js'
import {eventSystem} from '@/models/eventSystem.js'


const error = Object.freeze({
  "none": 0,
  "default": 1,
  "notImplemented": 2,
  "payload": 3,
  "server": 4
})
let errorToThrow = error.default;

const config = {
  // Just de/activates console.log when exceptions happen
  debug: false,
  storeID_newsletter: "newsletter",
  storeID_market: "market",
  storeID_meeting: "meeting",
  storeID_notSelling: "notSelling",
  eventID_newsletter: "newsletter",
  eventID_market: "market",
  eventID_meeting: "meeting",
  eventID_notSelling: "notSelling",
}

const interfaces = {
}

const apis = {
  event: eventSystem,
  browser: browser
}

const components = {
  
}

const calls = {
  newsletterSignup: async (commit, state, email) => {
    if (state.newsletterSignupEmail != null) {
      if (config.debug) {console.log("Newsletter already signed up");}
      return;
    }
    errorToThrow = error.payload;
    if (typeof(email) != "string") {
      throw Error("NewsletterSignup: email is not a string");
    }

    errorToThrow = error.default;
    commit("newsletterSignup", email);
    apis.browser.saveToLocalStorage(config.storeID_newsletter, {email: email}) 
    
    errorToThrow = error.server;
    apis.event.dispatch(config.eventID_newsletter, email);

    if (config.debug) {console.log("Newsletter Signup completed");}
  },

  marketSignup: async (commit, state, email) => {
    if (state.marketSignupEmail != null) {
      if (config.debug) {console.log("Market already signed up");}
      return;
    } 
    errorToThrow = error.payload;
    if (typeof(email) != "string") {
      throw Error("MarketSignup: email is not a string");
    }

    errorToThrow = error.default; 
    commit("marketSignup", email);
    apis.browser.saveToLocalStorage(config.storeID_market, {email: email}) 

    errorToThrow = error.server;
    apis.event.dispatch(config.eventID_market, email);

    if (config.debug) {console.log("Market Signup completed");}
  }, 

  meetingAccepted: async (commit, state, id) => {
    if (state.meetingID != null) {
      if (config.debug) {console.log("Meeting already accepted");}
      return;
    } 
    errorToThrow = error.payload;
    if (typeof(id) != "string") {
      throw Error("Meeting: ID is not a string");
    }

    errorToThrow = error.default; 
    commit("meetingAccepted", id);
    apis.browser.saveToLocalStorage(config.storeID_meeting, {id: id}) 

    errorToThrow = error.server;
    apis.event.dispatch(config.eventID_meeting, id);

    if (config.debug) {console.log("Meeting acception completed");}
  }, 

  notSelling: async (commit, state, id) => {
    if (state.notSellingID != null) {
      if (config.debug) {console.log("NotSelling already accepted");}
      return;
    } 
    errorToThrow = error.payload;
    if (typeof(id) != "string") {
      throw Error("NotSelling: ID is not a string");
    }

    errorToThrow = error.default; 
    commit("notSelling", id);
    apis.browser.saveToLocalStorage(config.storeID_notSelling, {id: id}) 

    errorToThrow = error.server;
    apis.event.dispatch(config.eventID_notSelling, id);

    if (config.debug) {console.log("Not Selling acception completed");}
  }, 

  setup: async (commit) => {
    const storeData_newsletter = apis.browser.getFromLocalStorage(config.storeID_newsletter);
    const storeData_market = apis.browser.getFromLocalStorage(config.storeID_market);
    const storeData_meeting = apis.browser.getFromLocalStorage(config.storeID_meeting);
    const storeData_notSelling = apis.browser.getFromLocalStorage(config.storeID_notSelling);
    if (storeData_newsletter != null) {
      if (config.debug) {console.log("Newsletter signup restored:", storeData_newsletter);}
      commit("newsletterSignup", storeData_newsletter.email);
    }
    if (storeData_market != null) {
      if (config.debug) {console.log("Market signup restored:", storeData_market);}
      commit("marketSignup", storeData_market.email);  
    } 
    if (storeData_meeting != null) {
      if (config.debug) {console.log("Meeting acception restored:", storeData_meeting);}
      commit("meetingAccepted", storeData_meeting.id);  
    } 
    if (storeData_notSelling != null) {
      if (config.debug) {console.log("Not selling restored:", storeData_notSelling);}
      commit("notSelling", storeData_notSelling.id);  
    } 

    apis.event.setup();
  }
}

const actions = {
  async appManagerDispatch(
    {commit, state, rootState, rootGetters}, //eslint-disable-line
    {action, payload}) { //eslint-disable-line
    errorToThrow = error.default;
    commit("loading", true);
    try {
      switch (action) {
      case 'setup':
        await calls.setup(commit);
        break;
      case 'newsletterSignup':
        await calls.newsletterSignup(commit, state, payload);
        break;
      case 'marketSignup':
        await calls.marketSignup(commit, state, payload);
        break; 
      case 'meetingAccepted':
        await calls.meetingAccepted(commit, state, payload);
        break; 
      case 'notSelling':
        await calls.notSelling(commit, state, payload);
        break; 
      default:
        errorToThrow = error.notImplemented;
        throw "Action '"+ action + "' is not implemented";
      }
      commit('clearError'); 
    } catch (Exception) {
      if (config.debug) {
        console.log("appManager: Reducer failed with ", Exception);
      }
      commit('error', errorToThrow) 
    }
    commit("loading", false);
  },
};


const state = {
  error: error.none,
  isLoading: false,
  newsletterSignupEmail: null,
  marketSignupEmail: null,
  meetingID: null,
  notSellingID: null,
};

const getters = {
  appManager: (state) => {
    return {
      errorName: Object.keys(error)[state.error],
      error: state.error,
      isLoading: state.isLoading,
    }
  },
  // To compare Errorstates less error proune
  appManagerError: () => {return Object.assign(error)}, 
};

const mutations = {
  error: (state, error) => {state.error = error;},
  clearError: (state) => {state.error = error.none;},
  loading: (state, isLoading) => {state.isLoading = isLoading;},
  newsletterSignup: (state, email) => {state.newsletterSignupEmail = email;},
  marketSignup: (state, email) => {state.marketSignupEmail = email;},
  meetingAccepted: (state, id) => {state.meetingID = id;},
  notSelling: (state, id) => {state.notSellingID = id;},
};

export default {
  state,
  getters,
  actions,
  mutations,
  calls,
  interfaces,
  apis,
  components,
  config,
}